import GroupIcon from "@mui/icons-material/Group"
import Icon from "@mui/material/Icon"
import ResetPassword from "layouts/authentication/reset-password"
import RestartPass from "layouts/authentication/reset-password/cover"
import Embed from "layouts/authentication/embed"
import SignIn from "layouts/authentication/sign-in"
import Change from "layouts/changepass"
import Dashboard from "layouts/dashboard"
import Dispositivos from "layouts/dispositivos"
import Devices from "layouts/dispositivos/components/add"
import Empresas from "layouts/empresas"
import Company from "layouts/empresas/components/add"
import AddServicios from "layouts/empresas/components/add/addServicios"
import AddDiccionario from "layouts/empresas/components/add/addDiccionario"
import Eventos from "layouts/eventos"
import Event from "layouts/eventos/components/add"
import AddServiciosEvento from "layouts/eventos/components/add/addServicios"
import Ingresos from "layouts/ingresos"
import IngresosRaw from "layouts/ingresos-raw"
import Liveness from "layouts/liveness"
import Reconocimiento from "layouts/reconocimiento"
import ReportCenterPage from "layouts/reportCenter"
import Roles from "layouts/roles"
import Rol from "layouts/roles/components/add"
import Sucursales from "layouts/sucursales"
import Branch from "layouts/sucursales/components/add"
import AddServiciosSucursal from "layouts/sucursales/components/add/addServicios"
import AddDiccionarioSucursal from "layouts/sucursales/components/add/addDiccionario"
import Usuarios from "layouts/usuarios"
import Add from "layouts/usuarios/add"
import Zonas from "layouts/zonas"
import Area from "layouts/zonas/components/add"
import Asistencia from "layouts/asistencia"
import AsistenteAdd from "layouts/asistencia/components/add"
import Organizaciones from "layouts/asistencia/dependencias"
import OrganizacionAdd from "layouts/asistencia/dependencias/components/add"
import TiposAsistente from "layouts/asistencia/tipos-asistente"
import TipoAsistenteAdd from "layouts/asistencia/tipos-asistente/components/add"
import ConfigAsistencia from "layouts/asistencia/configuraciones"
import ConfiguracionAdd from "layouts/asistencia/configuraciones/components/add"
import ReporteAsistencia from "layouts/asistencia/reportes"

const componentResolver = {
  Dashboard: <Dashboard />,
  Liveness: <Liveness />,
  // liveness: <Liveness />,
  Reconocimiento: <Reconocimiento />,
  Ingresos: <Ingresos />,
  IngresosRaw: <IngresosRaw />,
  Dispositivos: <Dispositivos />,
  Empresas: <Empresas />,
  Sucursales: <Sucursales />,
  Zonas: <Zonas />,
  Usuarios: <Usuarios />,
  Roles: <Roles />,
  Rol: <Rol />,
  Eventos: <Eventos />,
  ReportCenterPage: <ReportCenterPage />,
  Change: <Change />,
  SignIn: <SignIn />,
  Embed: <Embed />,
  ResetPassword: <ResetPassword />,
  RestartPass: <RestartPass />,
  Add: <Add />,
  AddServicios: <AddServicios />,
  AddServiciosSucursal: <AddServiciosSucursal />,
  AddServiciosEvento: <AddServiciosEvento />,
  AddDiccionario: <AddDiccionario />,
  AddDiccionarioSucursal: <AddDiccionarioSucursal />,
  Company: <Company />,
  Branch: <Branch />,
  Event: <Event />,
  Area: <Area />,
  Devices: <Devices />,
  Asistencia: <Asistencia />,
  AsistenteAdd: <AsistenteAdd />,
  Organizaciones: <Organizaciones />,
  OrganizacionAdd: <OrganizacionAdd />,
  TiposAsistente: <TiposAsistente />,
  TipoAsistenteAdd: <TipoAsistenteAdd />,
  ConfigAsistencia: <ConfigAsistencia />,
  ConfiguracionAdd: <ConfiguracionAdd />,
  ReporteAsistencia: <ReporteAsistencia />,
}

const iconResolver = (name) => {
  if (!name) return null
  if (name === "group") return <GroupIcon />
  return <Icon fontSize="small">{name}</Icon>
}

export const buildRoutesFromServer = (items = []) =>
  items.map((it) => {
    if (it.type === "divider") return { type: "divider", key: crypto.randomUUID() }
    if (it.type === "title") return { type: "title", title: it.name, name: it.name, key: it.name }

    const base = {
      type: it.type || "hidden",
      name: it.name,
      key: it.key || it.name?.toLowerCase().replace(/\s+/g, "-"),
      icon: iconResolver(it.icon),
      route: it.route,
      component: componentResolver[it.component],
    }

    if (Array.isArray(it.children) && it.children.length) {
      return { ...base, collapse: buildRoutesFromServer(it.children) }
    }
    return base
  })

const MyRoutes = () => {
  const routes = [
    {
      type: "hide",
      name: "Sign In",
      key: "sign-in",
      icon: <Icon fontSize="small">login</Icon>,
      route: "/authentication/sign-in",
      component: <SignIn />,
    },
    {
      type: "hide",
      name: "Embed Login",
      key: "embed-login",
      icon: <Icon fontSize="small">login</Icon>,
      route: "/embed",
      component: <Embed />,
    },
    {
      type: "hide",
      name: "Reset Password",
      key: "reset-password",
      icon: <Icon fontSize="small">login</Icon>,
      route: "/authentication/reset-password/cover",
      component: <RestartPass />,
    },
    {
      type: "hide",
      name: "Restablecer",
      key: "reset-password-submit",
      icon: <Icon fontSize="small">login</Icon>,
      route: "/reset-password",
      component: <ResetPassword />,
    },
  ]

  return routes
}

export default MyRoutes
